import { FeatureFlagEnum, TripType, hasFeatureFlag, parseBoolean, useGlobalContext, useSearch, } from '@honeycomb/data';
import { DiscountTypes } from '../../../utils/enums';
// Determine which of the hotel pricing pills we need to display based on the pricing summary
export const useHotelPricingPills = (pricingSummary) => {
    var _a, _b;
    const { configSettings: { HCPayDepositEnabled, HCEnablePayMonthly, HCPayDepositEnabledHotel }, } = useGlobalContext();
    const [search] = useSearch([]);
    const isDepositEnabled = parseBoolean(search.tripType === TripType.Hotel ? HCPayDepositEnabledHotel : HCPayDepositEnabled) ||
        hasFeatureFlag(FeatureFlagEnum.HOTEL_DEPOSITS);
    return {
        mobileDiscount: ((_a = pricingSummary === null || pricingSummary === void 0 ? void 0 : pricingSummary.discountTypes) === null || _a === void 0 ? void 0 : _a.includes(DiscountTypes.mobileDiscount)) || false,
        deposit: isDepositEnabled && ((pricingSummary === null || pricingSummary === void 0 ? void 0 : pricingSummary.deposit) || 0) > 0,
        payMonthly: (parseBoolean(HCEnablePayMonthly) && ((_b = pricingSummary === null || pricingSummary === void 0 ? void 0 : pricingSummary.monthlyInstalment) === null || _b === void 0 ? void 0 : _b.isAvailable)) || false,
    };
};
